import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { csvHelper } from "src/app/helpers/exporter/csvHelper";
import { IDirectoryUser } from "src/app/models/directory/users/DirectoryUser";

@Component({
    selector: 'request-details-service-account-disable',
    templateUrl: './request-details-service-account-disable.component.html'
})

export class RequestDetailsServiceAccountDisable implements OnChanges {
    @Input() requestData: IDirectoryUser[];
    @Output() doneLoading = new EventEmitter<boolean>();

    userDetailsDisplayColumns: string[] = ['userPrincipalName', 'type', 'domain', 'steward', 'serviceId', 'lastPasswordChangeDate'];
    defaultSortColumn: string = 'userPrincipalName';
    userDetails: any[] = [];

    constructor() { }

    exportDisabledServiceAccountDetailsToCsv() {
        const columns = this.userDetailsDisplayColumns;
        const csvData = csvHelper.ConvertToCSV(this.userDetails, columns);
        csvHelper.DownloadFile(csvData, `disabled-service-account-details-${new Date().toISOString()}`);
    }

    async ngOnChanges(): Promise<void> {
        if (this.requestData) {
            this.userDetails = this.requestData.map((user: any) => {
                return {
                    userPrincipalName: user.userPrincipalName,
                    type: user.type,
                    domain: user.domain,
                    steward: Array.isArray(user.stewards) && user.stewards.length > 0 ? user.stewards[0] : "",
                    serviceId: user.applicationId,
                    lastPasswordChangeDate: user.lastPasswordChangeDateTime,
                }
            });
            this.isDoneLoading();
        }
    }

    isDoneLoading() {
        this.doneLoading.emit(true);
    }
}